import { loginVerifyEcho } from './crm_ui/api/AuthRefreshAPI';
import * as crmRefreshPoller from './crm_ui/utils/crmRefreshPoller';
import I18n from 'I18n';
import AppContainer from './AppContainer';
import measure from 'crm-fe-perf/timing/measure';
import Routes from './router/Routes';
import { RenderApplicationToProfileMounted, ProfileMountedToRightSidebar, ProfileMountedToTimelineSuccess, ProfileMountedToHightlightDetails, RecordLeftLocationReadyToInitialCardsReady, RecordMiddleLocationReadyToInitialCardsReady, RecordRightLocationReadyToInitialCardsReady, SetupLoadedToSetupFetched } from 'crm-fe-perf/timing/measurements/crm-records-ui/performanceMeasurements';
import { getMeasureOptions } from './utils/getMeasureOptions';
import { observedPerformance } from './utils/observedPerformance';
import { prerenderSetup } from './appInit/prerenderSetup';
import AlertSetup from './setup/AlertSetup';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = async () => {
  // We split this out because we can't import from plus files and we want to
  // test it.
  await prerenderSetup();
  const measureOptions = getMeasureOptions();
  return {
    onAfterRender: () => {
      AlertSetup.setup();
      require('crm-records-ui/crm_ui/tracking/TrackMobileWebEvents');
      crmRefreshPoller.startOutdatedVersionPoll();
      setInterval(loginVerifyEcho,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Object' is not assignable to par... Remove this comment to see the full error message
      I18n.moment.duration(30, 'minutes').valueOf());
      const measureOptionsWithAssociationCardLocalStorage = getMeasureOptions({
        includeAssociationCardLocalStorage: true,
        includeIsActivitiesTab: true
      });
      measure(RenderApplicationToProfileMounted, measureOptions);
      measure(ProfileMountedToRightSidebar, measureOptionsWithAssociationCardLocalStorage);
      measure(ProfileMountedToTimelineSuccess, measureOptionsWithAssociationCardLocalStorage);
      measure(ProfileMountedToHightlightDetails, measureOptionsWithAssociationCardLocalStorage);
      measure(RecordLeftLocationReadyToInitialCardsReady, measureOptionsWithAssociationCardLocalStorage);
      measure(RecordMiddleLocationReadyToInitialCardsReady, measureOptionsWithAssociationCardLocalStorage);
      measure(RecordRightLocationReadyToInitialCardsReady, measureOptionsWithAssociationCardLocalStorage);
      measure(SetupLoadedToSetupFetched, measureOptionsWithAssociationCardLocalStorage);
      observedPerformance.logMetrics();
    }
  };
};
export function AppComponent() {
  return /*#__PURE__*/_jsx(AppContainer, {
    children: /*#__PURE__*/_jsx(Routes, {})
  });
}